/**
 * Environment configuration for PadelMaster.
 *
 * Only `BACKEND_URL` is consumed by the codebase. Endpoint paths live in
 * `src/Backend/config/api.ts` (`API_ENDPOINTS`); do not duplicate them here.
 */

const isDevelopment = import.meta.env.DEV;

const BACKEND_URLS = {
  // Em dev usamos caminhos RELATIVOS ('') para que os pedidos passem pelo proxy
  // do Vite (ver server.proxy no vite.config.ts), que reencaminha para o backend
  // definido em VITE_API_URL. Isto evita o erro de CORS de bater direto em
  // produção a partir do origin local.
  development: '',
  production: 'https://padelmasterclub-production.up.railway.app',
};

export const CONFIG = {
  BACKEND_URL: isDevelopment ? BACKEND_URLS.development : BACKEND_URLS.production,
};

export default CONFIG;
